import Users from '../components/Users'
import './UsersIndex.css'
function UsersIndex() {
  return (
    <div className='Index'>
      <h2 className='title'>
        Meet Our Game Switchers!
      </h2>
      <Users/>
    </div>
  )
}

export default UsersIndex
